import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserRequest } from '../models/Requests/UserRequest.model';
import { CampusRequest } from '../models/Requests/CampusRequest.model';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  apiUrl: string = "Location";
  constructor(private http: HttpClient) { }

  getDistrictsByUserRole(userRequest: UserRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(userRequest);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DistrictListByAccessLevel/', body, { headers: headers }).pipe(map(result => {
      return result.body;
    }));
  }

  getCampus(campusRequest: CampusRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(campusRequest);
    return this.http.post<any>(environment.baseUrl + 'Location/GetCampus/', body, { headers: headers }).pipe(map(data => {
      return data.body;
    }));
  }
}
